module.exports = __webpack_public_path__ + "static/media/transport.d76bbc8b.png";